import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodioComponent } from './simple-icons-codio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodioComponent ],
    exports:      [ SimpleIconsCodioComponent ],
    bootstrap:    []
})
export class SimpleIconsCodioModule {}
